import React from "react";
import { Container, Row, Col } from "react-grid-system";

// STYLES
import styled from "styled-components";

// SHARED
import { Section } from "../../shared/shared";

// COMPONENTS
import Title from "../../components/title/title.component";

// IMAGES
import Program_Image_1x from "../../images/network/img-rede-programa.png";
import Benefits_1x from "../../images/network/el-tabua.png";

export default class Program extends React.PureComponent {
  render() {
    let { t } = this.props;
    return (
      <Section className="backgroundColor fixPosition">
        <Container>
          <Image>
            <img src={Benefits_1x} alt="" />
          </Image>
          <Row>
            <Col sm={12} className="center">
              <Title text={t("ProgramTitle")} />
              <ProgramText>{t("ProgramDescription1")}</ProgramText>
              <ProgramText>{t("ProgramDescription2")}</ProgramText>
            </Col>
          </Row>
          <ProgramContent>
            <ProgramImg>
              <img src={Program_Image_1x} alt="" />
            </ProgramImg>
            <ProgramBox>
              <h5>{t("ProgramGoalsTitle")}</h5>
              <ul>
                <li>{t("ProgramGoal1")}</li>
                <li>{t("ProgramGoal2")}</li>
                <li>{t("ProgramGoal3")}</li>
                <li>{t("ProgramGoal4")}</li>
                <li>{t("ProgramGoal5")}</li>
                <li>{t("ProgramGoal6")}</li>
              </ul>
            </ProgramBox>
          </ProgramContent>
        </Container>
      </Section>
    );
  }
}

const ProgramText = styled.p`
  max-width: 770px;
  opacity: 0.8;
  color: hsl(0, 0%, 17%);
  font-family: "PT Sans";
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
  margin-top: 35px;
`;
const ProgramContent = styled.div`
  position: relative;
  width: 100%;
  margin-top: 25px;
`;
const ProgramImg = styled.div`
  text-align: right;

  img {
    width: 763px;
  }

  @media screen and (max-width: 992px) {
    display: none;
  }
`;
const ProgramBox = styled.div`
  position: relative;
  width: 663px;
  min-height: 412px;
  background-color: #ffffff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  margin-top: -364px;
  padding: 40px 20px;

  h5 {
    color: hsl(0, 0%, 17%);
    font-family: "PT Sans";
    font-size: 18px;
    font-weight: bold;
    line-height: 26px;
    text-transform: uppercase;
    text-align: left;
    margin-top: 0px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 30px;

    li {
      color: hsl(0, 0%, 17%);
      font-family: "PT Sans";
      font-size: 18px;
      line-height: 26px;
      margin-top: 21px;
    }
  }

  @media screen and (max-width: 992px) {
    margin-top: 50px;
    width: calc(100% - 40px);
  }
`;

const Image = styled.div`
  text-align: right;
  margin-top: -350px;
  padding-right: 25px;

  img {
    width: 520px;
    padding-bottom: 50px;
  }

  @media screen and (max-width: 1200px) {
    margin-top: -360px;
    img {
      width: 455px;
    }
  }

  @media screen and (max-width: 992px) {
    display: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/program/program.component.js